/**
 * Format a number as euro in Dutch locale, e.g. `€ 1.234,50`. Null/NaN → `—`.
 * Ported from the prototype `euro`.
 */
export function euro(n) {
    if (n == null || Number.isNaN(n))
        return '—';
    return ('€ ' +
        Number(n).toLocaleString('nl-NL', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }));
}
/** Parse a euro amount in NL/EN notation into a number, or null. */
export function parseEuro(raw) {
    if (raw == null)
        return null;
    if (typeof raw === 'number')
        return Number.isFinite(raw) ? raw : null;
    let s = String(raw).replace(/[€\s]/g, '');
    if (!s)
        return null;
    if (s.includes(',') && s.includes('.')) {
        if (s.lastIndexOf(',') > s.lastIndexOf('.'))
            s = s.replace(/\./g, '').replace(',', '.');
        else
            s = s.replace(/,/g, '');
    }
    else if (s.includes(',')) {
        s = s.replace(',', '.');
    }
    const n = Number(s);
    return Number.isFinite(n) ? n : null;
}
//# sourceMappingURL=money.js.map